import React, { Component } from 'react';
import { connect } from 'react-redux';
import Actions_Wind from '~/Actions_Wind';
import excel from '~/skills/excel';

import { EAA_Add_Btn } from '~/components/EditAndAddItem';
import PageTitle from '~/components/PageTitle';

import MaritimeList from './MaritimeList';
import ManufacturingProgramList from './ManufacturingProgramList';
import ManufacturingProcessList from './ManufacturingProcessList';

class Page_IAOverview extends Component {
  componentDidMount () { this.props.getIAOverviewData(); }
  componentWillUnmount () { this.props.clear(); }

  onExport=() => {
    const { IAOverviewData = {}, windfield_name } = this.props;
    const { wincontract_data = {} } = IAOverviewData;

    if (Object.keys(IAOverviewData).length === 0) alert('無匯出資料');
    else {
      excel.outputAryAry({
        data: [
          ['風場發起人', (IAOverviewData?.sub1 || []).map(o => o.all_sponsors).join('\n')],
          ['風場名稱', wincontract_data.windfield_name || '-'],
          ['獲配年度', `民國 ${wincontract_data.allocated_year || '-'} 年`, '風力機單機容量', `${IAOverviewData.set_total_capacity_start || '-'} ~ ${IAOverviewData.set_total_capacity_end || '-'} MW`],
          ['獲配容量', (IAOverviewData.sub2 || []).map(o => `${o.one_capacity || '-'} MW`).join('\n'), '風力機總數', (IAOverviewData.sub2 || []).map(o => `${o.frame_num || '-'} 座`).join('\n')],
        ],
        wrapText: true,
        fileName: `[${windfield_name}]產業關聯_總覽`,
      });
    }
  }

  render () {
    const { IAOverviewData = {} } = this.props;
    const { wincontract_data = {} } = IAOverviewData;
    return (
      <div style={{
        position: 'absolute',
        left: 13,
        right: 0,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        overflow: 'auto',
      }}
      >
        <PageTitle text='產業關聯_總覽' />
        <div style={{ marginTop: 12, display: 'flex' }}>
          <EAA_Add_Btn text='匯出資料' onClick={this.onExport} />
        </div>
        <div style={{ display: 'flex', marginTop: 24 }}>
          <div style={{ width: 120, fontSize: 16, fontWeight: 500, color: 'rgba(0,0,0,0.87)', marginRight: 24 }}>風場發起人</div>
          <div>
            {(IAOverviewData?.sub1 || []).map((o, i) => <div key={i} style={{ marginTop: i ? 9 : 0, fontSize: 18, fontWeight: 400, color: '#186279', textAlign: 'start' }}>{o.all_sponsors}</div>)}
          </div>
        </div>
        <div style={{ display: 'flex', marginTop: 24 }}>
          <div style={{ width: 120, fontSize: 16, fontWeight: 500, color: 'rgba(0,0,0,0.87)', marginRight: 24 }}>風場名稱</div>
          <div style={{ fontSize: 18, fontWeight: 400, color: '#186279', textAlign: 'start' }}>{wincontract_data.windfield_name}</div>
        </div>
        <div style={{ display: 'flex', marginTop: 24, width: '100%' }}>
          <div style={{ flex: 1, marginRight: 50, display: 'flex' }}>
            <div style={{ width: 120, fontSize: 16, fontWeight: 500, color: 'rgba(0,0,0,0.87)', marginRight: 24 }}>獲配年度</div>
            <div style={{ fontSize: 18, fontWeight: 400, flex: 1, textAlign: 'start' }}>民國</div>
            <div style={{ fontSize: 18, fontWeight: 400, color: '#186279', textAlign: 'start' }}>{wincontract_data.allocated_year}</div>
            <div style={{ width: 40, fontSize: 18, fontWeight: 400, textAlign: 'end' }}>年</div>
          </div>
          <div style={{ flex: 1, marginRight: 50, display: 'flex' }}>
            <div style={{ width: 120, fontSize: 16, fontWeight: 500, color: 'rgba(0,0,0,0.87)', marginRight: 24 }}>風力機單機容量</div>
            <div style={{ flex: 1 }} />
            <div style={{ fontSize: 18, fontWeight: 400, color: '#186279', textAlign: 'start' }}>
              {`${IAOverviewData.set_total_capacity_start || '-'} ~ ${IAOverviewData.set_total_capacity_end || '-'}`}
            </div>
            <div style={{ width: 40, fontSize: 18, fontWeight: 400, textAlign: 'end' }}>MW</div>
          </div>
        </div>
        <div style={{ display: 'flex', marginTop: 24, width: '100%' }}>
          <div style={{ flex: 1, marginRight: 50, display: 'flex' }}>
            <div style={{ width: 120, fontSize: 16, fontWeight: 500, color: 'rgba(0,0,0,0.87)', marginRight: 24 }}>獲配容量</div>
            <div style={{ flex: 1 }} />
            <div>
              {
                (IAOverviewData.sub2 || []).map((o, i) => (
                  <div key={i} style={{ display: 'flex', marginTop: i ? 9 : 0 }}>
                    <div style={{ fontSize: 18, fontWeight: 400, color: '#186279', textAlign: 'start' }}>{o.one_capacity || '-'}</div>
                    <div style={{ width: 40, fontSize: 18, fontWeight: 400, textAlign: 'end' }}>MW</div>
                  </div>
                ))
              }
            </div>
          </div>
          <div style={{ flex: 1, marginRight: 50, display: 'flex' }}>
            <div style={{ width: 120, fontSize: 16, fontWeight: 500, color: 'rgba(0,0,0,0.87)', marginRight: 24 }}>風力機總數</div>
            <div style={{ flex: 1 }} />
            <div>
              {
                (IAOverviewData.sub2 || []).map((o, i) => (
                  <div key={i} style={{ display: 'flex', marginTop: i ? 9 : 0 }}>
                    <div style={{ fontSize: 18, fontWeight: 400, color: '#186279', textAlign: 'start' }}>{o.frame_num || '-'}</div>
                    <div style={{ width: 40, fontSize: 18, fontWeight: 400, textAlign: 'end' }}>座</div>
                  </div>
                ))
              }
            </div>
          </div>
        </div>
        <MaritimeList />
        <ManufacturingProgramList />
        <ManufacturingProcessList />
      </div>
    );
  }
}
const mapStateToProps = state => ({
  IAOverviewData: state.data.IAOverviewData,
  windfield_name: state.data.WindIdDetail?.windfield_name,
});
const mapDispatchToProps = dispatch => ({
  getIAOverviewData: () => Actions_Wind.getIAOverviewData(dispatch),
  clear: () => Actions_Wind.clearKey(dispatch, { key: 'IAOverviewData' }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Page_IAOverview);
